import { useCallback, useEffect, useState } from 'react';
import BACKGROUND_MUSIC from '../assets/audio/background_music.wav';

export function useBackgroundMusic() {
    const [backgroundMusic] = useState(new Audio(BACKGROUND_MUSIC));

    const replay = useCallback(() => {
        backgroundMusic.currentTime = 0;
        backgroundMusic.play();
    }, [backgroundMusic]);

    const start = useCallback(() => {
        backgroundMusic.play();
        backgroundMusic.addEventListener('ended', replay);
    }, [backgroundMusic, replay]);

    useEffect(() => {
        return () => {
            backgroundMusic.removeEventListener('ended', replay);
        };
    }, [backgroundMusic, replay]);

    return start;
}
